import React from "react";
import InternalOrderList from "../../Internal/OrderList"

// Venue's Order inherits from Internal OrderList, but React can't do inheritance,
// so there is this composition instead
// You can use whatever name you want, this class could be called OrderList as well
class VenueOrderList extends React.Component {

  render() {

    return(
      <div className="OrderList">
        <InternalOrderList
          {...this.props}
          dataSource={"venue_admin/orders"}
          storeInputType="select"
          tableHeaders={{
            type: "",
            customerName: "Customer",
            status: "Status",
            method: "Method",
            storeName: "Store",
            total: "Total",
            lastFour: "Card",
            refunded: "Refunded?",
            placedAt: "Placed",
            view: "",
          }}
        />
      </div>
    )
  }
}

export default VenueOrderList
